module.exports = __webpack_public_path__ + "static/media/mobileSupportTile.23e6c95e.svg";